import { TransportGroupRvoReportResult } from '@tcc-mono/vandijk/shared/data-access/models';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'tcc-mono-transport-group-rvo-result-dialog',
  templateUrl: './transport-group-rvo-result-dialog.component.html',
  styleUrls: ['./transport-group-rvo-result-dialog.component.scss']
})
export class TransportGroupRvoResultDialogComponent {
  @Input() public rvoResults: TransportGroupRvoReportResult[];

}
